export enum CountiesEnum {
  Zagreb = 1,
  ZagrebCounty = 21,
  // Add other counties as needed
}
